interface PersonIconProps {
    fillColor?: string;
    strokeColor?: string;
    [key: string]: any;
}

export default function PersonIcon({ fillColor, strokeColor, ...props }: PersonIconProps): JSX.Element {
    return <svg aria-hidden="true"
        width={25}
        height={24}
        viewBox="0 0 25 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        {fillColor && <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.99997 6C7.99997 4.80653 8.47408 3.66193 9.31799 2.81802C10.1619 1.97411 11.3065 1.5 12.5 1.5C13.6934 1.5 14.838 1.97411 15.682 2.81802C16.5259 3.66193 17 4.80653 17 6C17 7.19347 16.5259 8.33807 15.682 9.18198C14.838 10.0259 13.6934 10.5 12.5 10.5C11.3065 10.5 10.1619 10.0259 9.31799 9.18198C8.47408 8.33807 7.99997 7.19347 7.99997 6ZM4.25097 20.105C4.28469 17.9395 5.16862 15.8741 6.71193 14.3546C8.25525 12.8351 10.3342 11.9834 12.5 11.9834C14.6658 11.9834 16.7447 12.8351 18.288 14.3546C19.8313 15.8741 20.7153 17.9395 20.749 20.105C20.7516 20.2508 20.7116 20.3942 20.634 20.5176C20.5564 20.641 20.4445 20.7392 20.312 20.8C17.8611 21.9237 15.1961 22.5037 12.5 22.5C9.71397 22.5 7.06697 21.892 4.68797 20.8C4.55546 20.7392 4.44355 20.641 4.36594 20.5176C4.28832 20.3942 4.24837 20.2508 4.25097 20.105Z"
            fill={fillColor}
        />}
        {strokeColor && <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.0001 6C8.0001 4.80653 8.4742 3.66193 9.31812 2.81802C10.162 1.97411 11.3066 1.5 12.5001 1.5C13.6936 1.5 14.8382 1.97411 15.6821 2.81802C16.526 3.66193 17.0001 4.80653 17.0001 6C17.0001 7.19347 16.526 8.33807 15.6821 9.18198C14.8382 10.0259 13.6936 10.5 12.5001 10.5C11.3066 10.5 10.162 10.0259 9.31812 9.18198C8.4742 8.33807 8.0001 7.19347 8.0001 6ZM4.2511 20.105C4.28482 17.9395 5.16874 15.8741 6.71206 14.3546C8.25538 12.8351 10.3343 11.9834 12.5001 11.9834C14.6659 11.9834 16.7448 12.8351 18.2881 14.3546C19.8315 15.8741 20.7154 17.9395 20.7491 20.105C20.7517 20.2508 20.7117 20.3942 20.6341 20.5176C20.5565 20.641 20.4446 20.7392 20.3121 20.8C17.8613 21.9237 15.1963 22.5037 12.5001 22.5C9.7141 22.5 7.0671 21.892 4.6881 20.8C4.55558 20.7392 4.44367 20.641 4.36606 20.5176C4.28844 20.3942 4.24849 20.2508 4.2511 20.105Z"
            stroke={strokeColor}
            strokeWidth={1.5}
            strokeLinecap="round"
            strokeLinejoin="round"
        />}
    </svg>
}

